const BackButton = () => import('frontend/components/core/BackButton')
const CriterionDetailsPage = () => import('frontend/pages/lpa/CriteriaDetailsPage')
const LPADetailsVersionPage = () => import('frontend/pages/lpa/DetailsVersionPage')
const LPASettingsPage = () => import('frontend/pages/lpa/SettingsPage')
const LPAVersionsPage = () => import('frontend/pages/lpa/VersionsPage')

import RemoteFilters from 'frontcore/presentation/remote-filters/views/RemoteFilters.vue'
import { LPA } from 'frontend/constants/callers'
import { SETTINGS_CARDS_TOKENS } from 'frontend/constants/settings'
import { TEMPLATE_FILTERS } from 'frontend/constants/filterUrls'

export const masterAuditSettingsTemplateRoute = (source) => {
  return [
    {
      path: `${source}`,
      name: SETTINGS_CARDS_TOKENS.settingTemplateConfiguration.name(source),
      components: {
        back: BackButton,
        default: LPASettingsPage,
        filters: RemoteFilters,
      },
      props: {
        back: { to: SETTINGS_CARDS_TOKENS.settingsOverview.name },
        default: { caller: source.toUpperCase(), source },
        filters: { filterURL: TEMPLATE_FILTERS },
      },
    },
    {
      path: `template-versions-${source}/:id`,
      name: SETTINGS_CARDS_TOKENS.templateVersionsConfiguration.name(source),
      components: {
        default: LPAVersionsPage,
      },
      props: {
        default: { caller: LPA, source },
      },
    },
    {
      path: `template-versions-${source}/:id/version/:version`,
      name: SETTINGS_CARDS_TOKENS.templateVersionsDetailConfiguration.name(source),
      components: {
        default: LPADetailsVersionPage,
      },
      props: {
        default: { caller: LPA, source },
      },
    },
    {
      path: `template-versions-${source}/:id/version/:version/criterion/:criterionId`,
      name: SETTINGS_CARDS_TOKENS.templateCriterionDetailConfiguration.name(source),
      components: {
        default: CriterionDetailsPage,
      },
      props: {
        default: { source },
      },
    },
    {
      path: `template-versions-${source}/:id/version/:version/criterion`,
      name: SETTINGS_CARDS_TOKENS.templateCriterionNewConfiguration.name(source),
      components: {
        default: CriterionDetailsPage,
      },
      props: {
        default: { source },
      },
    },
    {
      path: `template-versions-${source}/:id/version/:version/family/:familyId/criterion/:criterionId`,
      name: SETTINGS_CARDS_TOKENS.templateCriterionNewWithFamilyConfiguration.name(source),
      components: {
        default: CriterionDetailsPage,
      },
      props: {
        default: { source },
      },
    },
  ]
}
